import React from 'react';
import ReleaseItem from '../../lib/models/ReleaseItem';
import Star from './Star';
import ReleaseCard from './ReleaseCard';
import './ReleaseItemsViewer.scss';

interface ReleaseItemsViewerProps {
    name: string;
    env: string;
    items: ReleaseItem[];
    starred: Set<string>;
    onToggleTrackedRelease: (releaseItem: ReleaseItem) => void;
}

interface ReleaseItemsViewerState {
    viewMore: Map<string, boolean>;
}

export default class ReleaseItemsViewer extends React.Component<ReleaseItemsViewerProps, ReleaseItemsViewerState> {
    public constructor(props: ReleaseItemsViewerProps) {
        super(props);

        this.state = { viewMore: new Map() };
    }

    public render(): React.ReactNode {
        const vmKey = `${this.props.name}_${this.props.env}`;
        const showingMore = this.state.viewMore.has(vmKey) && this.state.viewMore.get(vmKey);
        const wanted = showingMore ? this.props.items.length : 3;
        const showing = this.props.items.slice(0, wanted > this.props.items.length ? this.props.items.length : wanted);
        const totalAvailable = this.props.items.length;

        return <>
            {showing.map((item) => {
                const isTracked = this.props.starred.has(item.version);

                return <div className='itemListContainer' key={item.id}>
                    <div className={'options ' + (isTracked ? 'tracked' : '')}>
                        <Star isSelected={isTracked} onSelected={() => this.props.onToggleTrackedRelease(item)} />
                    </div>
                    <ReleaseCard item={item} />
                </div>;
            })}

            {!showingMore && totalAvailable > showing.length
                ? <button onClick={() => {
                    const viewMore = new Map(this.state.viewMore);
                    viewMore.set(vmKey, true);
                    this.setState({ viewMore });
                }}>{totalAvailable - showing.length} more</button>
                : <></>}
        </>;
    }
}